import React, { useContext, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import {
  AppBar,
  Drawer,
  DrawerHeader,
  drawerList,
  drawerListGerm,
} from "./utility";
import drawerIcon from "../../assets/dashboard/heritageLogo.png";
import styles from "./DrawerComponent.module.css";
import { PRIMARYCOLOR } from "../../Utility/constants";
import { NavLink, Outlet } from "react-router-dom";
import { useLocation } from "react-router-dom";
import CustomSnackBar from "../CustomSnackBar/CustomSnackBar";
import { AppContext } from "../../ContextApi/AppContext/AppContext";
import Breadcrumbs from "../BreadCrumbs/BreadCrumbs";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import {
  consumCertGerText,
  germanText,
  needCertificateGerText,
} from "../../Utility/gerLangObject";
import {
  consumCertEngText,
  englisText,
  needCertificateEngText,
} from "../../Utility/engLangObject";
import { consumptionEngText, consumptionGermText } from "../Pannel/Pannel";
import { stringToYYYYMMDD } from "../../Utility/helper";

export default function MiniDrawer() {
  const {
    showSnackbar,
    state,
    handleCloseSnackbar,
    handleLogout,
    setState,
    setFormData,
    formData,
    pageState,
    setPageState,
  } = useContext(AppContext);
  const { language } = state;
  const [open, setOpen] = useState(true);
  const [active, setActive] = useState(1);
  const [openPop, setOpenPop] = useState(false);
  // useEffect(() => {
  //   console.log(token)
  //   if (token.access === "") handleLogout();
  // }, [token]);
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const location = useLocation();
  const basePath = location?.pathname.split("/")[1];

  useEffect(() => {
    if (basePath) {
      setFormData({
        form_status: [],
        payment_status: [],
        add_service: [],
        start_date: stringToYYYYMMDD(
          new Date(new Date().setMonth(new Date().getMonth() - 1))
        ),
        end_date: stringToYYYYMMDD(new Date()),
        search: "",
        certificate_status: [],
      });
      setPageState(1);
    }
  }, [basePath]);
  console.log(basePath, "basePath");
  useEffect(() => {
    const currentObject = drawerList.find((item, index) => {
      let str = location.pathname.replace(/^\/+/, "");
      return item.path === str;
    });
    if (currentObject) {
      setActive(currentObject.id);
    }
  }, [location]);

  const HandleOpenPop = () => {
    setOpenPop(!openPop);
  };
  const changeNavigate = (_type) => {
    setState((prev) => ({
      ...prev,
      language: _type,
    }));
  };
  useEffect(() => {
    if (language === "de") {
      setState((prev) => ({
        ...prev,
        headerLanguage: germanText,
        stepLanguage: consumCertGerText,
        needLanguage: needCertificateGerText,
      }));
    } else if (language === "en") {
      setState((prev) => ({
        ...prev,
        headerLanguage: englisText,
        stepLanguage: consumCertEngText,
        needLanguage: needCertificateEngText,
      }));
    }
  }, [language]);
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          edge="start"
          sx={{
            marginRight: 5,
            ...(open && { display: "none" }),
          }}
        >
          <MenuIcon />
        </IconButton>
        <Typography variant="h6" noWrap component="div">
          <div className={styles.headerContainer}>
            <div>
              <div
                style={{
                  display: "flex",
                  marginLeft: "auto",
                }}
              >
                <p
                  style={{
                    marginRight: "10px",
                    cursor: "pointer",
                    paddingBottom: "2px",
                    borderBottom: `1px solid ${
                      state.language !== "de" ? "white" : "#22a156"
                    }`,
                    fontWeight: `${state.language === "de" ? "900" : "400"}`,
                  }}
                  onClick={() => changeNavigate("de")}
                >
                  Deutsch
                </p>
                <p
                  style={{
                    marginRight: "10px",
                    cursor: "pointer",
                    paddingBottom: "2px",
                    borderBottom: `1px solid ${
                      state.language === "de" ? "white" : "#22a156"
                    }`,
                    fontWeight: `${state.language !== "de" ? "900" : "400"}`,
                  }}
                  onClick={() => changeNavigate("en")}
                >
                  English
                </p>
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <AccountCircleIcon
                fontSize="large"
                style={{ marginRight: "10px", cursor: "pointer" }}
                onClick={HandleOpenPop}
              />
              {openPop && (
                <div className={styles.pop} onClick={handleLogout}>
                  <p>
                    {language == "de"
                      ? consumptionGermText?.log_out
                      : consumptionEngText?.log_out}
                  </p>
                </div>
              )}
              <p style={{ textTransform: state.language === "en" ? "none" : "capitalize", margin: "0px" }}>
                {state?.user?.firstName}
              </p>
            </div>
          </div>
        </Typography>
      </AppBar>
      <Drawer variant="permanent" open={open}>
        <div style={{ color: "" }}>
          <div className={styles.imagelogoC}>
            <img
              alt="sama logo"
              src={drawerIcon}
              className={styles.imageLogo}
            />
          </div>
          <div className={styles.listingCon}>
            <div>
              {(language == "de" ? drawerListGerm : drawerList).map(
                (item, index) => {
                  return (
                    <NavLink
                      key={index}
                      className={({ isActive }) =>
                        [
                          styles.listingInd,
                          isActive ? styles.activeDiv : styles.inActiveDiv,
                        ].join(" ")
                      }
                      style={({ isActive }) => {
                        return {
                          color: `${isActive ? PRIMARYCOLOR : ""}`,
                          borderLeft: `${
                            isActive
                              ? `5px solid ${PRIMARYCOLOR}`
                              : "5px solid white"
                          }`,
                        };
                      }}
                      to={item.path}
                    >
                      <div className={styles.imageCon}>
                        {active === item.id ? (
                          <img
                            alt=""
                            src={item.active_icon}
                            style={{ width: "30px" }}
                          />
                        ) : (
                          <img
                            alt=""
                            src={item.inactive_icon}
                            style={{ width: "30px" }}
                          />
                        )}
                      </div>
                      <div>
                        <span>
                          <b>{item.title}</b>
                        </span>
                      </div>
                    </NavLink>
                  );
                }
              )}
            </div>
          </div>
        </div>
      </Drawer>
      <div style={{ width: "100%" }}>
        <div className={styles.outletContainer}>
          <Breadcrumbs />
          <Outlet />
        </div>
      </div>
      <CustomSnackBar open={state.snackbar} handleClose={handleCloseSnackbar} />
    </Box>
  );
}
